import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

interface product {
  name: string;
  productId: number;
}

@Component({
  selector: 'app-customer-product-price-list',
  templateUrl: './customer-product-price-list.component.html',
  styleUrls: ['./customer-product-price-list.component.css']
})
export class CustomerProductPriceListComponent implements OnInit {

  customerProductPriceList:any = [];
  singleCustomerProductPriceList:any = [];

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: any = 0
  isLoading: any = false
  id: any

  addCustomerProductPriceForm: any | FormGroup;
  editCustomerProductPriceForm: any | FormGroup;
  cid: any;
  formSubmit: boolean = false;

  productList: any = []
  products: product[] | any = [];
  selectedProduct: any;

  customerList: any = []
  customers: any = [];
  selectedCustomers: any;

  uomList: any = []
  uoms: any = [];
  selectedUOM: any;


  designationList:any = []
  designationDropdownList:any = [];
  designationSelectedList:any = [];
  designationDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'designationInfoId',
    textField: 'designationName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private generic_service: GenericService,
  ) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.addCustomerProductPriceForm = this.fb.group({
      description: [''],
      customerId: [''],
      productId: [''],
      uom: [''],
      minQty: [''],
      maxQty: [''],
      perUnitPrice: ['']
    })
    this.editCustomerProductPriceForm = this.fb.group({
      description: [''],
      customerId: [''],
      productId: [''],
      uom: [''],
      minQty: [''],
      maxQty: [''],
      perUnitPrice: [''],
      customerName: [''],
      productName: ['']
    })
    this.getAllProducts()
    this.getAllCustomerWithoutPagination()
    this.getAllUomMaster()
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.pageNumber1 = event;
    this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
  }

  getAllCustomerProductPrice(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllCustomerProductPrice(pageNumber,recordsPerPage).subscribe(
      (res:any)=> {
        console.log(res)
        this.customerProductPriceList = res.response.customerProductPriceList;
        this.totalRecords = res.response.totalRecords
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteDepartmentInfo(){
    this.generic_service.deleteCustomerProductPrice(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage);
        this.cancelModel();
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any){
    this.id = id
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllProducts(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response)
        this.productList = response.response;
        for(let list of response.response){
          this.products.push(
            {
              name: list.name,
              productId: list.productMasterId
            }
          )
        }
        console.log(this.products)

      }
    )
  }

  getAllCustomerWithoutPagination(){
    this.generic_service.getAllCustomerWithoutPagination().subscribe(
      (response:any)=>{
        console.log(response)
        this.customerList = response.response;
        for(let list of response.response){
          this.customers.push(
            {
              name: list.name,
              customerInfoId: list.customerInfoId
            }
          )
        }
      }
    )
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (response:any)=>{
        console.log(response)
        this.uomList = response.response;
        for(let list of response.response){
          this.uoms.push(
            {
              uomName: list.uomName,
              uomMasterId: list.uomMasterId
            }
          )
        }
      }
    )
  }

  addCustomerProductPrice(){
    this.formSubmit = true;

    console.log(this.selectedProduct)
    console.log(this.selectedCustomers)
    console.log(this.selectedUOM)
    
    let productId = this.selectedProduct.productId
    let productName = this.selectedProduct.name
    let uom = this.selectedUOM.uomName

    for(let list of this.selectedCustomers){
      const body = {
        "version": 0,
        "isActive": true,
        "description": this.addCustomerProductPriceForm.get('description').value,
        "customerId": Number(list.customerInfoId),
        "customerName": list.name,
        "productId": Number(productId),
        "productName": productName,
        "uom": uom,
        "minQty": Number(this.addCustomerProductPriceForm.get('minQty').value),
        "maxQty": Number(this.addCustomerProductPriceForm.get('maxQty').value),
        "perUnitPrice": Number(this.addCustomerProductPriceForm.get('perUnitPrice').value),
        "cid": Number(this.cid)
      }
      console.log(body);
  
      this.generic_service.addCustomerProductPrice(body).subscribe(
        (response: any)=>{
          console.log(response);
          // this.formSubmit = false;
          // this.toastr.success(response.message);
          // this.addCustomerProductPriceForm.reset();
        },
        (error: any)=>{
          console.log(error);
          // this.toastr.error(error.message);
          // this.formSubmit = false;
        }
      )
    }
    this.formSubmit = false;
    this.toastr.success('success');
    this.addCustomerProductPriceForm.reset();
    this.selectedProduct = [];
    this.selectedCustomers = [];
    this.selectedUOM = {};

  }



  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }


  editCustomerProductPrice(){

    const body = {
      "version": 0,
      "isActive": true,
      "description": this.editCustomerProductPriceForm.get('description').value,
      "id": this.singleCustomerProductPriceList.id,
      "customerProductPriceId": this.singleCustomerProductPriceList.customerProductPriceId,
      "customerId": Number(this.editCustomerProductPriceForm.get('customerId').value),
      "customerName": this.editCustomerProductPriceForm.get('customerName').value,
      "productId": Number(this.editCustomerProductPriceForm.get('productId').value),
      "productName": this.editCustomerProductPriceForm.get('productName').value,
      "uom": this.editCustomerProductPriceForm.get('uom').value,
      "minQty": Number(this.editCustomerProductPriceForm.get('minQty').value),
      "maxQty": Number(this.editCustomerProductPriceForm.get('maxQty').value),
      "perUnitPrice": Number(this.editCustomerProductPriceForm.get('perUnitPrice').value),
      "cid": Number(this.cid)
    }
    console.log(body);

    this.generic_service.updateCustomerProductPrice(body).subscribe(
      (response: any)=>{
        console.log(response);
        this.getAllCustomerProductPrice(this.pageNumber,this.recordsPerPage)
        this.formSubmit = false;
        this.toastr.success(response.message);
        this.editCustomerProductPriceForm.reset();
        this.cancelModel()
      },
      (error: any)=>{
        console.log(error);
        this.toastr.error(error.message);
        this.formSubmit = false;
      }
    )

  }

  getCustomerProductPriceByCustomerProductPriceId(customerProductPriceId: any){
    this.generic_service.getCustomerProductPriceByCustomerProductPriceId(customerProductPriceId).subscribe(
      (response:any)=> {
        console.log(response)
        this.singleCustomerProductPriceList = response.response;

        this.editCustomerProductPriceForm.patchValue(
          {      
            description: response.response.description,
            customerId: response.response.customerId,
            customerName: response.response.customerName,
            productId: response.response.productId,
            productName: response.response.productName,
            uom: response.response.uom,
            minQty: response.response.minQty,
            maxQty: response.response.maxQty,
            perUnitPrice: response.response.perUnitPrice
          }
        );
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

}
